
/**
 * applicare una classe j-target-togglr a un radio/checkbox o bottone per adottare
 * un comportamento simile a togglr (visibile/invisibile), e gestire la presenza
 * dell'attributo required in modo da non bloccare l'invio del form per i campi
 * nascosti.
 *
 * lo stato dell'input determina lo stato della pagina
 *
 * la classe che attiva il comportamento si **deve** chiamare come la classe
 * che identifica il nodo da accendere/spegnere, con il suffisso -togglr
 *
 * es.
 * <input type="checkbox" class="j-section-togglr">
 * <div class="j-section"></div>
 *
 * nota: le classi j-class sono comportamentali e quindi non hanno CSS associato
 * per mantenere la possibilità di applicare le classi j-whatever
 * a qualsiasi campo o nodo e nasconderlo indipendentemente dal suo supporto per
 * '.is-active', la visibilità di default è considerata visibile e questo togglr
 * inietta inline un display: none;
 */

const updateState = (targetClass, state) => {
	document.querySelectorAll(targetClass).forEach((el) => {
		// console.debug('updating', targetClass, state, el)
		if (state) {
			// will become visible
			el.style.display = null
			el.querySelectorAll('input, select').forEach((inputEl) =>
				inputEl.dataset['required'] !== undefined
					? inputEl.setAttribute('required', 'required')
					: null,
			)
		} else {
			// will become hidden
			el.style.display = 'none'
			el.querySelectorAll('input, select').forEach((inputEl) =>
				inputEl.removeAttribute('required'),
			)
		}
		el.classList.toggle('is-active', state)
	})
}

const init = (selector) => {
	const trigger = document.querySelector(`${selector}-togglr`)

	if (trigger) {
		const isInput = trigger.nodeName === 'INPUT'
		// add event listener
		// radio buttons do not trigger neither the input nor the change event
		// when they change based on a different radio button choice.
		if (isInput) {
			// console.debug('init input', trigger)
			if (trigger?.type === 'radio') {
				document
					.querySelectorAll(`[name="${trigger.name}"][type="radio"]`)
					.forEach((el) => {
						el.addEventListener('change', () => updateState(selector, trigger.checked))
					})
			} else {
				trigger.addEventListener('change', (evt) => updateState(selector, evt.currentTarget.checked))
			}
		} else {
			// console.debug('init node', trigger)
			trigger.addEventListener('click', (evt) => {
				evt.preventDefault()
				const state = document.querySelector(selector).classList.contains('is-active')
				updateState(selector, !state)
			})
		}

		// setup initial state
		const state = isInput
			? trigger.checked
			: document.querySelector(selector).classList.contains('is-active')
		updateState(selector, state)
	}
}

init('.j-business')
init('.j-address')
init('.j-new-address')
